// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__2hfEr","gfeWrapper":"CalendarEvent_gfeWrapper__3bFW1"};